import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { BlackInformationChip } from '@/components/Teleprompter/BlackInformationChip';
import DangerCircle from '@/images/DangerCircle.svg';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

const InfoContainer = styled.div`
    display: flex;
    align-items: center;
    color: white;
    gap: 8px;
    max-width: 500px;

    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.32px;

    p {
        font-size: 20.222px;
        font-weight: 700;
        letter-spacing: -0.404px;
    }

    a {
        color: ${({ theme }) => theme.colors.links};
        font-size: 16px;
        font-weight: 500;
        letter-spacing: -0.32px;
        margin-left: 4px;
    }
`;

export const PermissionDenied = () => {
    const theme = useTheme();

    return (
        <BlackInformationChip>
            <InfoContainer>
                <MaskedIcon src={DangerCircle} size="32px" color={theme.colors.error.main} />
                <div>
                    <p>Camera and microphone access blocked.</p>
                    Please allow the browser to access your camera and microphone and refresh the page.
                    <a>Need help?</a>
                </div>
            </InfoContainer>
        </BlackInformationChip>
    );
};
